export default "__VITE_ASSET__IYEutEmy__"